module.exports = __webpack_public_path__ + "img/title-products.9175706e.svg";